import * as React from 'react';

// Hooks
import { useTranslation, config } from '@shopee-user/platform';
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';

// Components
import { InputUsername } from '@shopee-user/input';

// Enums
import { Feature } from '@shopee-user/feature-toggle';

// Types
import type { InputProps } from '@shopee-user/input';

// Hooks

export const MAX_AUTH_KEY_LENGTH = 128;
export const MAX_PHONE_KEY_LENGTH = 64;

const InputLoginByOtpAuthKey = (props: InputProps) => {
  const I18n = useTranslation();

  const isPhoneAllowed = isFeatureEnabled(Feature.LoginByOtpAllowPhone);
  const isEmailAllowed = isFeatureEnabled(Feature.LoginByOtpAllowEmail);

  const getPlaceholderAndMaxLength = () => {
    if (isPhoneAllowed && isEmailAllowed) {
      return {
        placeholder: I18n.t('label_auth_phone_number_or_email_placeholder'),
        maxLength: MAX_AUTH_KEY_LENGTH,
      };
    } else if (isPhoneAllowed) {
      return {
        placeholder: I18n.t('label_auth_phone_number_placeholder', {
          context: config.LOCALE.toLocaleLowerCase(),
        }),
        maxLength: MAX_PHONE_KEY_LENGTH,
      };
    } else if (isEmailAllowed) {
      return {
        placeholder: I18n.t('label_auth_email_placeholder'),
        maxLength: MAX_AUTH_KEY_LENGTH,
      };
    } else {
      return { placeholder: '', maxLength: 0 };
    }
  };

  const { placeholder, maxLength } = getPlaceholderAndMaxLength();

  return (
    <InputUsername
      {...props}
      type="text"
      placeholder={placeholder}
      showErrorOutline
      showError
      autoFocus
      maxLength={maxLength}
    />
  );
};

export default InputLoginByOtpAuthKey;
